import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Rôle dans une équipe (enum App\Entity\TeamRole de l'API, GET /team_roles) : Manager, Équipier */
export default class TeamRoleModel extends AbstractApiModel {
  protected _path = '/team_roles/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:team_role:${this.id}`);
  }
}
